import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../lib/api';

export function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await api.login(email, password);
      navigate('/');
    } catch {
      // Generic message - the server never distinguishes unknown email
      // from wrong password, and neither should we.
      setError('Invalid email or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <img src="/logo.png" alt="Cap8" className="login-logo" />

      <div className="login-brand">
        <h1>Mnemo</h1>
        <p>Insight Engine</p>
      </div>

      <form className="login-box" onSubmit={handleSubmit}>
        <h2 className="login-title">Sign in to continue</h2>

        {error && <div className="alert alert-error">{error}</div>}

        <div className="form-group">
          <label className="form-label">Email</label>
          <input
            type="email"
            className="form-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@cap8.com"
            autoFocus
            required
          />
        </div>

        <div className="form-group">
          <label className="form-label">Password</label>
          <input
            type="password"
            className="form-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
            required
          />
        </div>

        <button
          type="submit"
          className="btn btn-primary"
          disabled={loading}
          style={{ width: '100%' }}
        >
          {loading ? 'Signing in...' : 'Sign In'}
          {!loading && (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
          )}
        </button>

        <p className="text-center text-muted mt-3" style={{ fontSize: '0.8125rem' }}>
          Don't have access? Contact Cap8 for an invitation.
        </p>
      </form>

      <div className="login-footer">
        Powered by <strong>Cap8</strong>
      </div>
    </div>
  );
}
